import React from "react";

// If a screen hits an error while drawing, show a message and a way back instead of a
// blank white page. The error is also logged to the console for debugging.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Screen failed to draw:", error, info && info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, boxSizing: "border-box", fontFamily: "system-ui, sans-serif", background: "#f6f6f4", color: "#1a1a1a" }}>
        <div style={{ maxWidth: 360, textAlign: "center" }}>
          <h1 style={{ fontSize: 20, margin: "0 0 8px" }}>Something went wrong</h1>
          <p style={{ fontSize: 14, margin: "0 0 18px", color: "#555" }}>
            This screen couldn't be shown. Your data is safe. Reload the app to carry on.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: "12px 20px", borderRadius: 12, border: "none", fontSize: 15, fontWeight: 700, cursor: "pointer", background: "#1a1a1a", color: "#fff" }}
          >
            Reload
          </button>
          <p style={{ fontSize: 11, margin: "16px 0 0", color: "#888", wordBreak: "break-word" }}>{String(this.state.error && this.state.error.message)}</p>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
